export function debounce<T extends (...args: any[]) => void>(
  callback: T,
  wait: number
) {
  let timeoutId: number;
  return (...args: Parameters<T>) =>
    new Promise((resolve) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        resolve(callback(...args));
      }, wait);
    });
}
